export default function vendorManagementAdminDirective() {
  console.log('app.components.admin.vendorManagementAdminDirective created');
  return {
    template: require('./vendor-management-admin.directive.html'),
    controller: 'VendorManagementAdminDirectiveController',
    controllerAs: 'vendorManagementAdminVM',
    bindToController: true,
    replace: true,
  };
}
